const eventConst = {
  EVENT_REFRESH_GLOBAL: 'EVENT_REFRESH_GLOBAL',
  EVENT_REFRESH_USER_MANAGER_PAGE: 'EVENT_REFRESH_USER_MANAGER_PAGE',
  EVENT_REFRESH_PROJECT_MANAGER_PAGE: 'EVENT_REFRESH_PROJECT_MANAGER_PAGE',
  EVENT_REFRESH_HOUSEHOLD_MANAGER_PAGE: 'EVENT_REFRESH_HOUSEHOLD_MANAGER_PAGE',
  EVENT_REFRESH_SOFTWARE_MANAGER_PAGE: 'EVENT_REFRESH_SOFTWARE_MANAGER_PAGE',
};

export default eventConst;
